import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCHenchCat1 extends NPC {
    constructor() {
        super(definitions.NPC_ID.HENCH_CAT_1);

        this.collisionRadius = 8;
        this.collisionOffsetX = 3;
        this.collisionOffsetY = -25;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_hench_cat_1_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(3, -6));
        this.animateIdle(0.4);
    }
}